import request from '@/utils/request';

export function getLotteryJoinDetail() {
  return request({
    url: '/Marketing/summerProjectLotteryJoin2019',
  });
}

export function getLotteryAssistDetail(flag) {
  return request({
    url: '/Marketing/summerProjectLotteryAssist2019',
    params: {
      flag,
    },
  });
}

export function lotteryAssist(flag) {
  return request({
    url: '/Marketing/lotteryAssist',
    method: 'POST',
    data: {
      flag,
    },
  });
}

export function lotteryJoin(data) {
  return request({
    url: '/Marketing/lotteryJoin',
    method: 'POST',
    data,
  });
}

export function lotteryShare(type) {
  return request({
    url: '/Marketing/lotteryShare',
    method: 'POST',
    data: {
      type,
    },
  });
}
